import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from "@sentry/react";
import App from './App';
import '../src/pages/dashboard/index.css'
import '../src/pages/equipment/index.css'
import '../src/pages/locations/index.css'
import './theme/Colors.css'
import store from './store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { initializeApp } from "firebase/app";
import * as config from './config'
import { printConsoleBanner } from './helpers/consoleBanner'

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
  });
}

const consoleMethods = [
  'assert',
  'clear',
  'count',
  'debug',
  'dir',
  'dirxml',
  'error',
  'exception',
  'group',
  'groupCollapsed',
  'groupEnd',
  'info',
  'profile',
  'profileEnd',
  'table',
  'time',
  'timeEnd',
  'timeStamp',
  'trace',
  'warn',
  // 'log'
];
consoleMethods.forEach(methodName => {
  console[methodName] = () => {
    /* noop */
  };
});

printConsoleBanner();

const firebaseConfig = {
  apiKey: config.API_KEY,
  authDomain: config.AUTH_DOMAIN,
  projectId: config.PROJECT_ID,
  storageBucket: config.STORAGE_BUCKET,
  messagingSenderId: config.SENDER_ID,
  appId: config.APP_ID,
  measurementId: config.MEASUREMENT_ID

};

export const firebaseApp = initializeApp(firebaseConfig);
// export const messaging = getMessaging(firebaseApp);
window.addEventListener("error", (event) => {
  if (
    event.message ===
    "ResizeObserver loop completed with undelivered notifications."
  ) {
    event.stopImmediatePropagation();
  }
});
if ("serviceWorker" in navigator) {

  navigator.serviceWorker.register('../firebase-messaging-sw.js').then((res) => {
  }).catch(() => {
    //  'service worker registration failed',
  }
  )

  // navigator.serviceWorker.getRegistration().then(reg => {
  // reg.showNotification('title', {});
  // navigator.serviceWorker.addEventListener("message", event => {
  //   console.dir("sdsdsdsd",event.data);
  // });
  // });
}
const container = document.getElementById('root');
const root = createRoot(container)
root.render(
  <Sentry.ErrorBoundary fallback={<p>An error has occurred. Our team has been notified.</p>}>
    <Provider store={store}>
      <App/>
    </Provider>
  </Sentry.ErrorBoundary>
);

serviceWorker.unregister();